import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "../../../../toolkit/uicomponentcss";

export interface DefaultFlashCardCSSStyle extends UIComponentCSSStyle
{
    getToneWrapperCSSStyle(): object;
    getImgCSSStyle(): object;
    getOnHoverCSSStyle(): object;
    getMobileToneWrapperCSSStyle(): object;
    getMobileImgCSSStyle(): object;
    getMobileOnHoverCSSStyle(): object;
}

export class DefaultFlashCardCSSStyleImpl extends UIComponentCSSStyleImpl implements DefaultFlashCardCSSStyle
{
    getToneWrapperCSSStyle(): object
    {
        return { 
            // marginRight: "40px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'50px 0px 50px 0px',
            backgroundImage: "url('" + this.getContext().getResources().getImage("flash_message_blue.png") + "')",
            backgroundSize: "cover",
            boxShadow:"5px 5px 5px 5px  #F4F4F4",
            paddingLeft:"30px",
            justifyContent:"center",
            paddingRight:"30px"
        };
    }

    getOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            display: "flex",
            background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '280px',
            borderRadius: "50px 0px 50px 0px",
        };
    }

    getDetailsDivCssStyle(): object 
    {
        return {
            objectFit: 'cover', 
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }
    getMobileToneWrapperCSSStyle(): object
    {
        return {
            height: '140px', 
            width: '131px', 
            marginTop: "70px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'25px 0px 25px 0px'
        };
    }

    getMobileOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            height: '140px', 
            width: '131px', 
            borderRadius:'25px 0px 25px 0px',
            display: "flex",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "20px",
            background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }

    getMobileImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '140px',
            borderRadius: "25px 0px 25px 0px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/defaultflashcard/defaultflashcardcss.tsx